// import React from 'react';

// import PropTypes from 'prop-types';
// import { Form } from 'react-final-form';
// import { connect } from 'react-redux';

// import { AppWrapper, LoginForm, OnlyFormPageWrapper } from 'components';
// import { AuthorizedRedirect } from 'containers';
// import { actions } from 'coupon-common/src/modules/auth';
// import { dispatchAsAsync } from 'coupon-common/src/utils';

// export const Login = ({ dispatch }) => {
//   const onSubmit = async values => {
//     const { email, password } = values;

//     return dispatchAsAsync(actions.login(email, password), dispatch);
//   };

//   return (
//     <AppWrapper showHeader={false} bgLight contentCentered>
//       <OnlyFormPageWrapper forLogin>
//         <AuthorizedRedirect />
//         <Form onSubmit={onSubmit} component={LoginForm} />
//       </OnlyFormPageWrapper>
//     </AppWrapper>
//   );
// };

// Login.propTypes = {
//   dispatch: PropTypes.func,
// };

// export default connect()(Login);

import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-final-form';
import { FORM_ERROR } from 'final-form';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Helmet } from 'react-helmet';
import { AuthorizedRedirect } from 'containers';
import { actions } from 'coupon-common/src/modules/auth';
import { dispatchAsAsync } from 'coupon-common/src/utils';

import Logo from '../../containers/Authentication/Logo';
import LoginForm from '../../components/LoginForm/LoginForm';
import '../Authentication/AuthFlow.css';

import IMG_LOGIN_HERO from '../../assets/images/login_hero.png';

const NAV_LINKS = ['Home', 'Features', 'How It Works', 'Pricing', 'Resources'];

export const Login = ({ dispatch }) => {
  const onSubmit = async values => {
    const { email, password } = values;
    const submitErrors = await dispatchAsAsync(actions.login(email, password), dispatch);

    if (submitErrors) {
      // Wrapped in FORM_ERROR so react-final-form treats this as a
      // form-level error (LoginForm's `submitError` prop) rather than
      // a field-level error keyed by whatever the object's shape is.
      // Generic message on purpose — doesn't reveal whether the email
      // or the password was the wrong one.
      return { [FORM_ERROR]: 'Incorrect email or password. Please try again.' };
    }
  };

  return (
    <div className="auth-page auth-login-page">
      <Helmet>
  <title>Sign In | My Couponbook</title>
  <meta name="description" content="Access your personalized feed of local deals and manage your rewards." />
</Helmet>
      <AuthorizedRedirect />
      <img src={IMG_LOGIN_HERO} alt="" className="auth-login-bg" />
      <div className="auth-login-scrim" />

      {/* ── top nav ── */}
      <header className="auth-navbar">
        <Logo light />
        {/* <nav className="auth-navlinks">
          {NAV_LINKS.map((l, i) => (
            <a key={l} href="#" className={`auth-navlink${i === 0 ? ' is-active' : ''}`}>
              {i === 0 && <span className="auth-navlink-dot" />}
              {l}
            </a>
          ))}
        </nav> */}
        <button type="button" className="auth-btn auth-btn-solid auth-navbar-cta">
          Get Started Free
        </button>
      </header>

      {/* ── headline ── */}
      <div className="auth-login-marketing">
        <h1 className="auth-login-headline">
          Turn Offers<br />into<br /><span>Opportunities.</span>
        </h1>
      </div>

      {/* ── login card ── */}
      <div className="auth-card-wrap">
        <div className="auth-card">
          <h2 className="auth-card-title">
            Welcome to<br /><span>Couponbook</span>
          </h2>
          <Form onSubmit={onSubmit} component={LoginForm} />
        </div>
      </div>
    </div>
  );
};

Login.propTypes = {
  dispatch: PropTypes.func,
};

export default connect()(Login);